import ShopApiClient from './ShopApiClient';

class CouponAPI extends ShopApiClient {
  constructor() {
    super('coupons', { accountScoped: true });
  }

  applyCoupon(payload){
    // return axios.get(`${this.url}?name=${merchantName}`);
    return axios.post(`${this.url}/apply_coupon`,payload);
  }
}

export default new CouponAPI();
